import React, { useLayoutEffect } from "react";
import "../Css/PrivacyPolicy.css";

const TermsConditions = (()=>{
    useLayoutEffect(() => {
        window.scrollTo(0, 0)
    });
    return(
        <>
         <section className="privacy-policy-section-main-con">
                <div className="container">
                    <div className="privacy-policy-section-details-main-con">
                        <div className="privacy-policy-section-details-head-con">
                            <h3>Terms & Conditions</h3>
                        </div>
                        <div className="privacy-policy-section-details-con">
                            <div className="privacy-policy-section-details-con-head-para">
                                <h4>Terms & Conditions</h4>
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque fuga sit debitis omnis non, veritatis dolor porro incidunt ullam dicta totam, placeat iste perferendis perspiciatis modi exercitationem harum, ab dolore.</p>
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque fuga sit debitis omnis non, veritatis dolor porro incidunt ullam dicta totam, placeat iste perferendis perspiciatis modi exercitationem harum, ab dolore.</p>
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque fuga sit debitis omnis non, veritatis dolor porro incidunt ullam dicta totam, placeat iste perferendis perspiciatis modi exercitationem harum, ab dolore.</p>
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque fuga sit debitis omnis non, veritatis dolor porro incidunt ullam dicta totam, placeat iste perferendis perspiciatis modi exercitationem harum, ab dolore.</p>
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque fuga sit debitis omnis non, veritatis dolor porro incidunt ullam dicta totam, placeat iste perferendis perspiciatis modi exercitationem harum, ab dolore.</p>
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque fuga sit debitis omnis non, veritatis dolor porro incidunt ullam dicta totam, placeat iste perferendis perspiciatis modi exercitationem harum, ab dolore.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
});

export default TermsConditions;